import React, { useEffect, useState } from "react";

type Props = {
    text: string;
    intervalMs?: number; // opzionale, default: 500ms
    maxDots?: number;    // opzionale, default: 3
};

const AnimatedDotsText = ({ text, intervalMs = 300, maxDots = 3 }: Props) => {
    const [dots, setDots] = useState("");

    useEffect(() => {
        const interval = setInterval(() => {
            setDots(prev => prev.length >= maxDots ? "" : prev + ".");
        }, intervalMs);
        return () => clearInterval(interval);
    }, [intervalMs, maxDots]);

    return <span>{text}{dots}</span>;
};

export default AnimatedDotsText;
